import Modal from "@/components/ui/modal";

interface VideoModalProps {
    youtubeId: string;
    open: boolean;
    onClose: () => void;
}

const VideoModal = ({ youtubeId, open, onClose }: VideoModalProps) => {
    return (
        <Modal open={open} onClose={onClose} className="bg-black p-0">
            {open && (
                <div className="aspect-video w-full">
                    <iframe
                        src={`https://www.youtube.com/embed/${youtubeId}?autoplay=1`}
                        title="YouTube video player"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        loading="lazy"
                        className="w-full h-full"
                    />
                </div>
            )}
        </Modal>
    );
};

export default VideoModal;

